export const footerData = {
  logo: {
    src: "/assets/reg_logo.webp",
    alt: "Company Logo",
    link: "/",
  },
  description:
    "Transforming the way individuals learn and network for professional excellence!",
  inputPlaceholder: "Input your email here",
  socialLinks: [
    {
      url: "https://facebook.com",
      iconClass: <i className="fa-brands fa-youtube"></i>,
    },
    {
      url: "https://twitter.com",
      iconClass: <i className="fa-brands fa-linkedin-in"></i>,
    },
    {
      url: "https://linkedin.com",
      iconClass: <i className="fa-brands fa-instagram"></i>,
    },
    {
      url: "https://linkedin.com",
      iconClass: <i className="fa-brands fa-square-x-twitter"></i>,
    },
  ],
  contact: {
    email: " support@regenesys ",
    phone: " +27 7204287636",
  },
  sections: {
    schools: [
      { text: "School of Business", url: "/school-of-business" },
      { text: "School of Public Management", url: "/school-of-it" },
      { text: "School of Finance", url: "/school-of-law" },
      { text: "School of Technology", url: "/school-of-law" },
      { text: "LAW School", url: "/school-of-law" },
    ],
    resources: [
      { text: "Research & Initiatives", url: "/library" },
      { text: "Events", url: "/e-learning" },
      { text: "Insights and Highlights", url: "/career-services" },
      { text: "Publications", url: "/career-services" },
      { text: "Newsletter", url: "/career-services" },
      { text: "Get Student Funding", url: "/career-services" },
    ],
    regenesys: [
      { text: "About us", url: "/about-us" },
      { text: "Student Reviews", url: "/our-team" },
      { text: "Leadership", url: "/contact-us" },
      { text: "Careers", url: "/contact-us" },
      { text: "Referral Programme", url: "/contact-us" },
      { text: "EdForAll", url: "/contact-us" },
    ],
  },
  policies: [
    { text: "Terms & Conditions", url: "/about-us" },
    { text: "Privacy Policy", url: "/about-us" },
    { text: "Refund Policy", url: "/about-us" },
  ],
  copyright: "Copyright © 2024 - Regenesys Business School",
};
